<template>

  <div>
    <v-layout class="banner">
      <div class="banner-img"></div>
    </v-layout>

    <v-container class="intro">
      <v-row>
        <v-col cols="12" lg="6">
          <div class="inner">
            <h5 class="title-sm">Riiqo Customer</h5>
            <h1>Customer Management Upgraded to Easy!</h1>
            <router-link to="contact" class="btn">Get Started</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>
    
    <div class="riiqosxn riiqosxn-bar">
      <h1 class="riiqosxn-title">Features</h1>
      <div class="mod-bar">
        <div class="mod-bar__line"></div>
        <div class="mod-bar__dot"></div>
      </div>
    </div>

    <div class="riiqosxn riiqosxn-page-features">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="5" class="riiqosxn-content">
            <h1>Customer <br>Page Features</h1>
            <div class="mod-list">
              <div class="mod-list__item">
                <div class="mod-img mod-img--dragndrop"></div>
                <div class="mod-content">
                  <h4 class="mod-title">DYNAMIC DRAG & DROP</h4>
                  <p>Create your own experience. Drag and drop as many field types as you need to manage customer information.</p>
                </div>
              </div>
              <div class="mod-list__item">
                <div class="mod-img mod-img--tag"></div>
                <div class="mod-content">
                  <h4 class="mod-title">Tagging for easy search</h4>
                  <p>Tag customers for easy search and sort. Tag different lead types that automatically import from your website.</p>
                </div>
              </div>
              <div class="mod-list__item">
                <div class="mod-img mod-img--history"></div>
                <div class="mod-content">
                  <h4 class="mod-title">History of changes</h4>
                  <p>Full history of all things Customer is always there for you to keep accountability</p>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <div class="riiqosxn-img"></div>
    </div>

    <div class="riiqosxn riiqosxn-milestone">
      <v-container>
        <v-row>
          <v-col cols="12" sm="8" xl="7" class="col-img">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="4" xl="5" class="riiqosxn-content">
            <h1>Milestones</h1>
            <p>Create Customer processes and follow them through the most important steps. Automatically notify your customers as they progress.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-invoice">
      <v-container>
        <h2 class="riiqosxn-title">Invoice, Collect & Record</h2>
        <v-row class="mod-invoice">
          <v-col cols="12" sm="6" md="5"  class="mod-invoice__item">
            <h4 class="mod-title">Invoice With Riiqo</h4>
            <p>Quickly create invoices from scratch. Send them to your customers and let them pay from the invoice portal, with all details recorded for you in transaction history.</p>
          </v-col>
          <v-col cols="12" sm="6" md="5" offset-md="1" class="mod-invoice__item">
            <h4 class="mod-title">Use with quickbooks</h4>
            <p>Connect your Quickbooks online account with RIIQO and automatically record your transactions the way you like. Or invoice through Quickbooks using the Riiqo system.</p>
          </v-col>
          <v-col cols="12" sm="6" md="5" class="mod-invoice__item">
            <h4 class="mod-title">Transaction history</h4>
            <p>Riiqo will automatically record and save your transaction history. See all your transactions, including point of sale with beautiful, easy to read charts.</p>
          </v-col>
          <v-col cols="12" sm="6" md="5" offset-md="1" class="mod-invoice__item">
            <h4 class="mod-title">Record in quick books</h4>
            <p>Plug in your processor and give your customers an easy way to pay. Find out about their experience with customer reviews and assure a good experience.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-processor">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="col-img">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="6" class="col-content riiqosxn-content">
            <h1>Choose your processor</h1>
            <ul>
              <li>We are integrated with some of the most popular processors used today, including: Square, Stripe, Paypal, and Quickbooks.</li>
              <li>You can collect card information with your customer face to face and complete the full transaction with just a few clicks.</li>
              <li>Send an invoice to your customer and have them pay from a remote, secure window. We will save all the necessary data you need about your customer purchasing.</li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-shoppingcart">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="col-content riiqosxn-content">
            <h1>Use existing shopping cart</h1>
            <ul>
              <li>We integrate easily with Shopify, and Woo Commerce to make your product search and check out simple and familiar.</li>
              <li>Are your products already in your processing account? We can pull your products from those accounts as well, ensuring that your inventory is up-to-date in real time.</li>
              <li>Automatically update the products that were purchased in the right categories you already use in Quickbooks.</li>
            </ul>
          </v-col>
          <v-col cols="12" sm="6" class="col-img"></v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-calendar">
      <div class="riiqosxn-img"></div>
      <v-container>
        <v-row class="row-f">
          <v-col cols="12" sm="6"></v-col>
          <v-col cols="12" sm="6" class="riiqosxn-content">
            <h1>Not Just Calendar Features You Need, But The Ones You Want</h1>
            <p>With a full integration of Google Calendars, you will feel right at home. You can create a task in calendar and see how your employees are doing at getting the job done.</p>
            <div class="mod-icons">
              <div class="mod-row">
                <div class="mod-row__item calendar"></div>
                <div class="mod-row__item gmaps"></div>
              </div>
            </div>

          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-calendar-features">
      <v-container>
        <v-row class="mod-cal-features">
          <v-col cols="2" class="mod-cal-features__item">
            <div class="icon notes"></div>
            <h4>Add Notes</h4>
          </v-col>
          <v-col cols="2" class="mod-cal-features__item">
            <div class="icon repeat"></div>
            <h4>Repeat Event</h4>
          </v-col>
          <v-col cols="2" class="mod-cal-features__item">
            <div class="icon reminders"></div>
            <h4>Set Reminders</h4>
          </v-col>
          <v-col cols="2" class="mod-cal-features__item">
            <div class="icon invite"></div>
            <h4>Invite Members</h4>
          </v-col>
          <v-col cols="2" class="mod-cal-features__item">
            <div class="icon colors"></div>
            <h4>Add Unique Colors</h4>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-connections">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="col-content riiqosxn-content">
            <h1>Connections</h1>
            <p>Having customers in context with others that are affiliated with them is nice. With connections you can do just that. Simply add a connection, and access their info inside the customer’s profile.</p>
          </v-col>
          <v-col cols="12" sm="6" class="col-img"></v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-map">
      <v-container>
        <v-row>
          <v-col cols="12" class="riiqosxn-content">
            <h1>Visualize your <br>Company’s Footprint</h1>
            <p>With Google Maps integration, you can see where your success is coming from. We give you multiple ways to break down the map which ensures you take care of the areas where your company is growing the most.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-map-features">
      <v-container fluid>
        <div class="calendar-features">
          <v-tabs-items v-model="calendarFeatureTab" class="calendar-features-tab-item">
            <v-tab-item
              transition="fade-transition" reverse-transition="fade-transition"
              v-for="cfi in calendarFeatureTabItems"
              :key="'cfi'+cfi.name"
            >
              <div class="v-window-item-image" :style="{ 'background-image': `url(/assets/images/customer/${cfi.image})` }"></div>
            </v-tab-item>
          </v-tabs-items>
          <v-tabs 
            v-model="calendarFeatureTab"
            background-color="transparent"
            class="calendar-features-tab">
            
            <v-tab v-for="cf in calendarFeatureTabItems" :key="'cf'+cf.name">
              <span class="icon" :class="cf.icon"></span>
              <div class="tab-name">{{ cf.name }}</div>
            </v-tab>
            <v-tab-item v-for="cfc in calendarFeatureTabItems" :key="'cfc'+cfc.name">
              {{ cfc.content }}
              <template v-if="cfc.name == 'Status'">
                <div class="mod-status-opt">
                  <div class="mod-row">
                    <div class="mod-row__item"
                      v-for="so in statusOptions"
                      :key="'so'+so.name">
                      <div class="mod-icon" :style="{ 'background-image': `url(/assets/images/customer/${so.icon})` }"></div>
                      {{ so.name }}
                    </div>
                    <div class="mod-row__item">And More</div>
                  </div>
                </div>
              </template>
            </v-tab-item>
          </v-tabs>
        </div>

      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-favorites">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="col-img">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="6" class="col-content riiqosxn-content">
            <h1>Favorites</h1>
            <p>It’s nice to save favorites. Save time, and access your favorites from your customer page, with a click instead of searching.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-history">
      <div class="riiqosxn-img"></div>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="5" class="riiqosxn-content">
            <h1>Complete History for Accountability</h1>
            <p>Make sure that users are accountable for what they are doing with your customers. An ongoing history is available so you always know what’s going on.</p>
          </v-col>
          <v-col cols="12" sm="6" md="7"></v-col>
        </v-row>
      </v-container>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Intro',

  data: () => ({
    calendarFeatureTab: null,
    calendarFeatureTabItems: [
      { 
        name: 'Density', 
        icon: '_circle_bold', 
        image: 'maps_density.svg',
        content: 'See where the largest concentration of your customers are so you can focus on the right areas when it comes to sales and customer service.' 
      },
      { 
        name: 'Status', 
        icon: '_status_bold', 
        image: 'maps_status.svg',
        content: 'Want to know the status or disposition of your leads or existing customers? Just mark them in their profile, and see it on the map, so when you are in the area, there is no need to guess.' 
      },
      { 
        name: 'Purchases', 
        icon: '_dollar_bold', 
        image: 'maps_purchases.svg',
        content: 'Coming Soon: Visualize where you are making the most money. It’s one thing to see where your customers are, but even more valuable when you can see which areas are spending the most money on your products or services. You’ll really know where to advertise.' 
      },
      { 
        name: 'Events', 
        icon: '_schedule_bold', 
        image: 'maps_events.svg',
        content: 'Need to know the route for the day? Anytime you tag one or more customers to an event, easily create a route that can be sent to your Maps on your mobile device, so you GPS can guide you through your list of jobs.' 
      }
    ],
    statusOptions: [
      { name: 'Closed', icon: 'closed-icon.png' },
      //{ name: 'Left Voicemail', icon: 'left-voicemail-icon.png' },
      //{ name: 'Moved', icon: 'moved-icon.png' },
      { name: 'Appointment', icon: 'appointment-icon.png' },
      { name: 'Contacted', icon: 'contacted-icon.png' },
      { name: 'Not Interested', icon: 'not-interested-icon.png' },
      { name: 'Not Available', icon: 'not-available-icon.png' }
      //{ name: 'Wrong Number', icon: 'wrong-number-icon.png' },
      //{ name: 'Disqualified', icon: 'disqualified-icon.png' },
      //{ name: 'Callback', icon: 'callback-icon.png' },
      //{ name: 'No Answer', icon: 'no-answer-icon.png' },
      //{ name: 'Wait', icon: 'wait-icon.png' }
    ]
  }),
};
</script>
